import { Component, OnInit, computed, signal, Signal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FloorplanStore } from 'src/app/stores/floorplan.store';
import { FloorPlanInfo } from 'src/app/interfaces/interfaces';

@Component({
  selector: 'app-add-favorite-maps-modal',
  templateUrl: './add-favorite-maps-modal.component.html',
  styleUrls: ['./add-favorite-maps-modal.component.scss'],
})
export class AddFavoriteMapsModalComponent  implements OnInit {
  
  // Local search query signal
  private _searchQuerySignal = signal<string>('');
  
  // Computed signal for filtered not favorite floorplans
  public filteredNotFavoriteFloorplans: Signal<FloorPlanInfo[]> = computed(() => {
    const allNotFavoriteFloorplans = this.floorplanStore.notFavoriteFloorplansList();
    const searchQuery = this._searchQuerySignal();
    
    return allNotFavoriteFloorplans.filter(floorplan => this.floorplanStore.filterFloorplans(floorplan, searchQuery));
  });
  
    constructor(private modalController: ModalController,public floorplanStore: FloorplanStore,private translateService : TranslateService) {
   }

  ngOnInit() {}


  searchMapsBySearchBar(query = '') {
    this._searchQuerySignal.set(query);
  }

  dismissModal() {
    return this.modalController.dismiss('close');
  }
}
